module.exports = __webpack_public_path__ + "img/vacation.f97c54fb.png";